import React from 'react';
import * as PropTypes from 'prop-types';
import thumbnail from '../assets/thumbnail.svg';
import { mediaReference } from '../utils/ipfs';

const ImageOnLoad = (props) => {
    const [loadedSrc, setLoadedSrc] = React.useState(null);
    const [loadedPreview, setLoadedPreview] = React.useState(null);
    const [cdn, setCdn] = React.useState(null);

    React.useEffect(() => {
        setCdn(null);
        let medium = null;
        let standard = null;
        if (props.cdn && props.cdn.length) {
            props.cdn && props.cdn.map((val) => {
                if (val.indexOf('/medium') > -1) {
                    medium = val;
                } else if (val.indexOf('/standard') > -1) {
                    standard = val;
                }

                return null;
            });
        } else {
            return;
        }

        if (medium) {
            const image = new Image();
            image.onload = () => {
                setCdn(medium);
            };
            image.src = medium;
        } else if (standard) {
            const image = new Image();
            image.onload = () => {
                setCdn(standard);
            };
            image.src = standard;
        }
    }, [props.cdn]);

    React.useEffect(() => {
        setLoadedPreview(null);
        if (props.cdn && props.cdn.length) {
            return;
        }
        if (props.preview) {
            const url = mediaReference(props.preview);
            const image = new Image();
            image.onload = () => {
                setLoadedPreview(url);
            };
            image.onerror = () => {
                setLoadedPreview(thumbnail);
            };
            image.src = url;
        }
    }, [props.preview, props.cdn]);

    React.useEffect(() => {
        setLoadedSrc(null);
        if (props.cdn && props.cdn.length) {
            return;
        }
        if (props.src) {
            const url = mediaReference(props.src);
            const image = new Image();
            image.onload = () => {
                setLoadedSrc(url);
            };
            image.onerror = () => {
                setLoadedSrc(props.defaultThumbnail || thumbnail);
            };
            image.src = url;
        }
    }, [props.src, props.cdn]);

    if (cdn) {
        const obj = {
            src: cdn,
        };

        if (props.alt) {
            obj.alt = props.alt;
        }

        return (
            <img {...obj} alt="thumbnail"/>
        );
    } else if (loadedSrc) {
        const obj = {
            src: loadedSrc,
        };

        if (props.alt) {
            obj.alt = props.alt;
        }

        return (
            <img {...obj} alt="thumbnail"/>
        );
    } else if (loadedPreview) {
        const obj = {
            src: loadedPreview,
        };

        if (props.alt) {
            obj.alt = props.alt;
        }

        return (
            <img {...obj} alt="thumbnail"/>
        );
    }

    return <div className="default_thumbnail">
        {props.letter
            ? <span style={{
                width: '70px',
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50px',
                background: props.background ? props.background : '#CBD6FF',
                color: props.textColor ? props.textColor : '#FFF',
                textTransform: 'capitalize',
                fontSize: '16px',
                fontWeight: 500,
                fontFamily: 'Poppins, sans-serif',
            }}>{props.letter && props.letter.substr(0, 2)}</span>
            : <img alt="thumbnail" src={props.defaultThumbnail || thumbnail}/>}
        {props.text
            ? <p>{props.text}</p>
            : null}
    </div>;
};

ImageOnLoad.propTypes = {
    alt: PropTypes.string,
    background: PropTypes.string,
    cdn: PropTypes.array,
    className: PropTypes.string,
    defaultThumbnail: PropTypes.any,
    letter: PropTypes.string,
    preview: PropTypes.string,
    src: PropTypes.string,
    text: PropTypes.string,
    textColor: PropTypes.string,
};

export default ImageOnLoad;
